import { Clock, FileDown, FileSpreadsheet } from "lucide-react";
import { generateProposalPDF } from "@/lib/pdfGenerator";
import { generateBudgetSpreadsheet } from "@/lib/spreadsheetGenerator";

/**
 * Quiet courtesy strip between Hero and Story.
 * Sets expectations: full proposal length, alternate download formats.
 * Council members appreciate the upfront read-time disclosure.
 */
export default function ReadTimeStrip() {
  return (
    <section
      data-testid="read-time-strip"
      className="bg-[#F9F7F1] border-y border-[#CBD5E1] py-5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center gap-3">
          <Clock className="h-4 w-4 text-[#8B0000]" />
          <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-[#475569]">
            Full proposal · ~12 minute read · or download below
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <button
            type="button"
            data-testid="read-time-pdf"
            onClick={generateProposalPDF}
            className="inline-flex items-center gap-2 border border-[#0A192F] text-[#0A192F] hover:bg-[#0A192F] hover:text-[#F9F7F1] h-9 px-4 font-mono text-[10px] uppercase tracking-widest transition-colors"
          >
            <FileDown className="h-3.5 w-3.5" /> Proposal · PDF
          </button>
          <button
            type="button"
            data-testid="read-time-xlsx"
            onClick={generateBudgetSpreadsheet}
            className="inline-flex items-center gap-2 border border-[#0A192F] text-[#0A192F] hover:bg-[#0A192F] hover:text-[#F9F7F1] h-9 px-4 font-mono text-[10px] uppercase tracking-widest transition-colors"
          >
            <FileSpreadsheet className="h-3.5 w-3.5" /> 5-Yr Financials · XLSX
          </button>
        </div>
      </div>
    </section>
  );
}
